import React, { useEffect, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const TIERS = [
  { k: "1", l: "1 j" }, { k: "2", l: "2 j" }, { k: "3", l: "3 j" }, { k: "4", l: "4 j" },
  { k: "5", l: "5 j" }, { k: "6", l: "6 j" }, { k: "7", l: "7 j" }, { k: "long_day", l: "+7 j /jour" },
];

const Catalog = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get("/admin/products").then((r) => { setProducts(r.data); setLoading(false); });
  useEffect(() => { load(); }, []);

  const save = async (p, patch) => { await api.patch(`/admin/products/${p.id}`, patch); toast.success("Enregistré"); };
  const savePricing = (p, key, val) => {
    const pricing = { ...(p.pricing || {}), tiers: { ...(p.pricing?.tiers || {}) } };
    if (key === "long_day") pricing.long_day = Number(val);
    else pricing.tiers[key] = Number(val);
    save(p, { pricing });
  };
  const [uploadingId, setUploadingId] = useState(null);
  const uploadPhoto = async (p, file) => {
    if (!file) return;
    setUploadingId(p.id);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.patch(`/admin/products/${p.id}`, { image: `${BACKEND}${data.url}` });
      toast.success("Photo mise à jour");
      load();
    } catch (e) { toast.error("Échec de l'upload"); } finally { setUploadingId(null); }
  };

  if (loading) return <div className="grid place-items-center h-64"><Loader2 className="w-10 h-10 animate-spin text-brand" /></div>;

  return (
    <div>
      <h1 className="font-heading font-extrabold text-3xl text-ink mb-3">Matériel & Tarifs</h1>
      <p className="text-ink-muted mb-8">Modifiez les tarifs dégressifs et la caution. Enregistrement automatique à la sortie du champ.</p>
      <div className="space-y-5">
        {products.map((p) => (
          <div key={p.id} className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm" data-testid={`catalog-${p.category}`}>
            <div className="flex items-center gap-4 mb-4">
              <img src={p.image} alt="" className="w-16 h-16 rounded-xl object-cover bg-slate-50" />
              <div className="flex-1"><h3 className="font-heading font-bold text-xl text-ink">{p.name.fr}</h3><span className="text-sm text-ink-muted">{p.category}</span></div>
              <label data-testid={`upload-${p.category}`} className="cursor-pointer flex items-center gap-2 px-4 h-11 rounded-full border-2 border-slate-200 hover:border-brand font-semibold text-sm">
                {uploadingId === p.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Changer la photo
                <input type="file" accept="image/*" className="hidden" onChange={(e) => uploadPhoto(p, e.target.files[0])} />
              </label>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
              {TIERS.map((t) => (
                <div key={t.k}><label className="text-xs text-ink-muted block mb-1">{t.l} €</label>
                  <input type="number" defaultValue={t.k === "long_day" ? p.pricing?.long_day : p.pricing?.tiers?.[t.k]} onBlur={(e) => savePricing(p, t.k, e.target.value)} data-testid={`price-${p.category}-${t.k}`} className="w-full h-11 rounded-lg border-2 border-slate-200 px-2" /></div>
              ))}
              <div><label className="text-xs text-ink-muted block mb-1">Caution €</label>
                <input type="number" defaultValue={p.deposit} onBlur={(e) => save(p, { deposit: Number(e.target.value) })} className="w-full h-11 rounded-lg border-2 border-slate-200 px-2" /></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Catalog;
